'use client';

import { FC, useRef } from 'react';

import { useAtomValue } from 'jotai';

import { userIdAtom } from '@core/Atoms/User/UserId.atom';
import { ctaClickedToEvent } from '@tracking/Schemas/CtaClicked/CtaClickedToEvent';
import { userContextToEvent } from '@tracking/Schemas/UserContext/UserContextToEvent';
import { trackCustomEvent } from '@tracking/Utils/TrackCustomEvent';

import { EvSpecsMessages } from './EvSpecs.messages';

import styles from './EvSpecs.module.css';

type Props = {
  strings: EvSpecsMessages;
};

export const EvSpecsShowMoreButton: FC<Props> = ({ strings }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const userId = useAtomValue(userIdAtom);

  const handleToggle = () => {
    const isExpanded = inputRef.current?.checked;

    const ctaEventObj = {
      ctaType: 'link',
      ctaWording: isExpanded ? strings.showLess : strings.showMore,
      ctaLocation: 'ev_specs_pdp',
      targetUrl: window.location.href,
    };

    const userData = { userId, values: {} };
    const event = ctaClickedToEvent(ctaEventObj);
    const userEvent = userContextToEvent(userData);

    trackCustomEvent({ event, context: [userEvent] });
  };

  return (
    <span className={styles.showToggle}>
      <input type="checkbox" id="showToggle" ref={inputRef} />
      <label htmlFor="showToggle" className={styles.showMore} onClick={handleToggle}>
        {strings.showMore}
      </label>
      <label htmlFor="showToggle" className={styles.showLess} onClick={handleToggle}>
        {strings.showLess}
      </label>
    </span>
  );
};
